import { ContactFormInputNames } from '@gik/contact/enums/ContactFormInputNames';
import { translationKeys } from '@gik/contact/i18n/en';
import i18n from '@gik/i18n';
import type { FormSchemaEntry } from '@gik/ui/Form';

export const contactFormSchema: () => FormSchemaEntry[] = () => [
  {
    label: i18n.t(translationKeys.ContactFormNameInputLabel),
    name: ContactFormInputNames.Name,
    required: true,
    type: 'text',
  },
  {
    label: i18n.t(translationKeys.ContactFormEmailInputLabel),
    name: ContactFormInputNames.EmailAddress,
    required: true,
    type: 'email',
  },
  {
    label: i18n.t(translationKeys.ContactFormMessageInputLabel),
    name: ContactFormInputNames.Message,
    required: true,
    type: 'textarea',
  },
  {
    name: ContactFormInputNames.SignUpNewsletter,
    required: false,
    type: 'checkbox',
    props: {
      label: i18n.t(translationKeys.ContactFormSignUpNewsletterInputLabel),
    },
  },
];
